let initialState = {
  sharedAccount: null,
  sharedBrands: null,
  sharedDuration: null,
  share_selected_deepdive_widget: null,
  allow_multiple_brand: false,
  profileSelectionInfo: {
    is_value_updated_from_share_modal: false,
    allow_multiple_selection: false,
    profile_list: [],
    profileInfo: null,
    quick_filter_value: null,
    adsset_list: [],
    adsset_value: null,
    ads_list: [],
    ads_value: null,
    selected_profile: null,
  },
};
const Share = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SHARED_BRANDS":
      return {
        ...state,
        sharedBrands: action.payload,
      };
    case "SET_SHARED_ACCOUNT":
      return {
        sharedAccount: action.payload,
      };
    case "SET_SHARED_DURATION":
      return {
        ...state,
        sharedDuration: action.payload,
      };
    case "SET_SHARE_SELECTED_DEEPDIVE_WIDGET":
      return {
        ...state,
        share_selected_deepdive_widget: action.payload,
      };
    case "RESET_SHARE_SELECTED_PROFILE_SELECTION_INFO":
      return {
        ...state,
        profileSelectionInfo: {
          ...initialState.profileSelectionInfo,
        },
      };
    case "SET_INITIAL_SHARE_SELECTED_QUICK_FILTER_VALUES":
      return {
        ...state,
        profileSelectionInfo: {
          ...state.profileSelectionInfo,
          profileInfo:
            action?.profileInfo ?? state?.profileSelectionInfo?.profileInfo,
          quick_filter_value:
            action?.qucikFilterValue ??
            state?.profileSelectionInfo?.quick_filter_value,
          adsset_list: action?.adssetList?.length > 0 ? action?.adssetList : [],
          adsset_value: action?.adssetValue ? action?.adssetValue : null,
          ads_list: action?.adsList?.length > 0 ? action?.adsList : [],
          ads_value: action?.adsValue ? action?.adsValue : null,
        },
      };
    case "SET_SHARE_SELECTED_QUICK_FILTER_VALUE":
      return {
        ...state,
        profileSelectionInfo: {
          ...state.profileSelectionInfo,
          is_value_updated_from_share_modal: true,
          profileInfo:
            action?.profileInfo ?? state?.profileSelectionInfo?.profileInfo,
          quick_filter_value:
            action?.qucikFilterValue ??
            state?.profileSelectionInfo?.quick_filter_value,
        },
      };
    case "SET_ADSSET_LIST_IN_SHARE_MODAL":
      return {
        ...state,
        profileSelectionInfo: {
          ...state.profileSelectionInfo,
          is_value_updated_from_share_modal: true,
          adsset_list: action?.adssetList?.length > 0 ? action?.adssetList : [],
        },
      };
    case "SET_ADSSET_VALUE_IN_SHARE_MODAL":
      return {
        ...state,
        profileSelectionInfo: {
          ...state.profileSelectionInfo,
          is_value_updated_from_share_modal: true,
          adsset_value: action?.adssetValue ? action?.adssetValue : null,
        },
      };
    case "SET_ADS_LIST_IN_SHARE_MODAL":
      return {
        ...state,
        profileSelectionInfo: {
          ...state.profileSelectionInfo,
          is_value_updated_from_share_modal: true,
          ads_list: action?.adsList?.length > 0 ? action?.adsList : [],
        },
      };
    case "SET_ADS_VALUE_IN_SHARE_MODAL":
      return {
        ...state,
        profileSelectionInfo: {
          ...state.profileSelectionInfo,
          is_value_updated_from_share_modal: true,
          ads_value: action?.adsValue ? action?.adsValue : null,
        },
      };
    default:
      return state;
  }
};

export default Share;
